module.exports = __webpack_public_path__ + "assets/img/main-type-6.5e3122ab.svg";